(function () {
    'use strict';

    angular
        .module('app.user')
        .component('ubStepWizardHelpSection', {
            bindings: {
                currentStep: '<'
            },
            controller: UserOnboardingStepWizardHelpSection,
            controllerAs: 'vm',
            templateUrl: 'app/user/dashboard/onboard/wizard/help/user.onboard.wizard.help.html'
        });

    /* @ngInject */
    function UserOnboardingStepWizardHelpSection($q) {
        var vm = this;
        vm.$onInit = onInit;

        function onInit() {

        }
    }
})();
